import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDatepicker } from "@angular/material/datepicker";
import { CAPService } from "../../core/services/cap-service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import * as CryptoJS from "crypto-js";
import { formatDate } from "@angular/common";
import { Router } from "@angular/router";
import { GridOptions } from "ag-grid-community";
//import 'ag-grid-enterprise';
// import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// import * as alasql from "alasql";
// import * as XLSX from "xlsx";
import * as $ from "jquery";
import { FormGroup, FormBuilder } from "@angular/forms";

@Component({
  selector: "app-summary-reports",
  templateUrl: "./summary-reports.component.html",
  styleUrls: ["./summary-reports.component.css"],
})
export class SummaryReportsComponent implements OnInit {
  @ViewChild("InitiatedDate") InitiatedDate: MatDatepicker<Date>;
  @ViewChild("endDate") endDate: MatDatepicker<Date>;
  // @ViewChild("CountryList") public CountryList: DropDownListComponent;
  public CountryList:any="";
  public Reports: ReportDetails = new ReportDetails();
  public dlstDeviceType;
  public SummaryDeviceTypeList;
  public dlstReportType;
  public dlstCountry;
  public ReportTypes;
  public Countries;
  public FacilityList;
  public LocationList;
  public SourceCountries;
  public DestinationCountries;
  public CallTypeListTeams;
  public checkbox1 = false;
  public SelectedEnterpriseIDList;
  public SelectedEnterpriseIDInList;
  public showRecEIdlistbox = false;
  public GatewayList;
  public ProjectList;
  public DestinationTypeList;
  public DialInConferenceList;
  public Country;
  public Role;
  public RoleReport;
  public Utilizations;
  public PhoneMessage;
  public RetriveData;
  public IsRetriveData: boolean = false;
  public ProjectName = [];
  public Description = [];
  public Gateways = [];
  public DailInConff = [];
  public CallTypes = [];
  public DestinationTypes = [];
  public DeviceType;
  public ReportType;
  public gridOptions: GridOptions;
  public columnDefs;
  public rowData;
  public defaultColDef;
  public gridApi;
  public gridColumnApi;
  public excelStyles;
  public dropDownSettings: IDropdownSettings;
  public IsDataToExport: boolean;
  public loaderGif: boolean = false;
  public selectedFacilities = [];
  public selectedProjectNames = [];
  public selectedGateways = [];
  public selectedDailInConff = [];
  public selectedDest = [];
  public slectedCallType = [];
  public selectedLocation = [];
  /* Div Conrols */
  public chkCountryReportType = false;
  public divSourceCountry = false;
  public divDestinationCountry = false;
  public SrcDestCountry = true;
  IsCountryChecked = false;
  dynamicVariable = false;
  public divLocationReport = false;
  CountryFields: Object = { text: "Country", value: "Country" };
  bulkFile: any;
  public BulkUploaddata;
  public TempUserKey = "";
  public LoginEnterpriseID;
  summaryReportFG: FormGroup;
  public divcountrymultiselectType = false;
  public MultiCountrySummaryFlag = false;
  public CountrySummaryFlag = true;
  public slectedCountries = [];
  public slectedToCountries = [];
  public divcountryselectType = true;
  public MultiSelectCountriesTeams;
  public MultiSelectToCountriesTeams;
  public cntrydropDownSettings: IDropdownSettings;
  public selectedSMECluster = [];
  public SMENameList;

  public customDrpDwnSettings: IDropdownSettings = {
    itemsShowLimit: 1,
    idField: "label_id",
    allowSearchFilter: true,
    textField: "label",
    selectAllText: "Check All",
    unSelectAllText: "UnCheck All",
    maxHeight: 100,
    searchPlaceholderText: "Search",
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: "No data available",
  };

  public customCntryDrpDwnSettings: IDropdownSettings = {
    itemsShowLimit: 1,
    idField: "label_id",
    allowSearchFilter: true,
    textField: "label",
    selectAllText: "All",
    unSelectAllText: "All",
    maxHeight: 100,
    searchPlaceholderText: "Search",
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: "data available",
  };

  public divcallType = false;
  public divFacility = false;
  public divAuthcode = false;
  public divGateway = false;
  public divProjectName = false;
  public divCommonareaPhone = false;
  public divteamscall1 = false;
  public divteamscall3 = false;
  public diveid = false;
  public divevent = false;
  public divConference = false;
  public authRange = true;
  public authCode = false;
  public IsAuth = false;
  public divSMEcluster = false;
  public bulkeid = false;
  public singleeid = false;
  public EIDList;

  public country = "";
  public Type = "";
  // public dropDownListObject: DropDownListComponent;
  public dropDownListObject:any="";
  public href = "";

  constructor(
    private CAPService: CAPService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.SummaryDeviceTypeList = [{ name: "Cisco" }, { name: "Teams" }];
    this.dlstDeviceType = "";
    this.dlstReportType = "";
    this.dlstCountry = "";
    this.PhoneMessage = "Phone Number";
    this.Reports.Country = "";
    this.Reports.SourceCountry = "";
    this.Reports.DestinationCountry = "";
    this.Reports.startDateTime = "";
    this.Reports.EndDate = "";
    this.Reports.WBSE = "";
    this.Reports.RequestNumber = "";
    this.Reports.AuthCode = null;
    this.Reports.fromAuthcode = null;
    this.Reports.toAuthcode = null;
    this.Reports.eId = "";
    this.Reports.Empno = "";
    this.Reports.AuthStatus = "";
    this.Reports.callingPartyNumber = "";
    this.Reports.CallerNo = "";
    this.Reports.CalleeNo = "";
    this.Reports.Event = "";
    this.Country = CAPService.country;
    this.Role = CAPService.ReportRole;
    this.RoleReport = CAPService.Role;
    this.LoginEnterpriseID = CAPService.enterpriseid;
    this.href = window.location.href;
    this.DestinationTypeList = [
      { label_id: 0, label: "Local" },
      { label_id: 1, label: "National" },
      { label_id: 2, label: "International" },
      { label_id: 3, label: "Incoming" },
      { label_id: 4, label: "Tollfree" },
    ];
    //This code to redirect to India URL from Frankfrut server//
    // if (this.Country == 'India' && this.RoleReport == 'Global Admin') {
    //   window.open("https://mycalls-india.accenture.com", "_blank")
    // }
    //------------------------------------------------------//
    if (this.RoleReport == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {
    this.dropDownSettings = {
      itemsShowLimit: 1,
      idField: "label_id",
      textField: "label",
      singleSelection: false,
      selectAllText: "Check All",
      unSelectAllText: "UnCheck All",
      maxHeight: 100,
    };

    this.CAPService.CountryList("N", "ReportsCountry").subscribe((data) => {
      this.Countries = data;
      debugger;
      this.MultiSelectCountriesTeams = data;
      const MultiCountryTypeObj = { MultiCountryTypeArray: [] };
      for (let i = 1; i < data.length; i++) {
        const CountryType = { label_id: i, label: data[i].Country };
        MultiCountryTypeObj.MultiCountryTypeArray.push(CountryType);
      }
      this.MultiSelectCountriesTeams =
        MultiCountryTypeObj.MultiCountryTypeArray;
    });
    this.CAPService.SourceCountryList("N", "N").subscribe((data) => {
      this.SourceCountries = data;
    });
    this.CAPService.DestinationCountryList("N", "N").subscribe((data) => {
      this.DestinationCountries = data;
      this.MultiSelectToCountriesTeams = data;
      const MultiToCountryTypeObj = { MultiToCountryTypeArray: [] };
      for (let i = 1; i < data.length; i++) {
        const ToCountryType = { label_id: i, label: data[i].Country };
        MultiToCountryTypeObj.MultiToCountryTypeArray.push(ToCountryType);
      }
      this.MultiSelectToCountriesTeams =
        MultiToCountryTypeObj.MultiToCountryTypeArray;
    });
    this.CAPService.DropdownValues("Utilization", "Cisco").subscribe((data) => {
      this.Utilizations = data;
    });

    this.summaryReportFG = this.fb.group({
      inputFile: "",
    });
    this.EIDList = [{ name: "Single" }, { name: "Bulk" }];

    $(document).ready(function () {
      $("#dlstCountry").find("span").removeAttr("role");
    });
  }
  EIDTypeEvent(event: any) {
    const type = event.target.value;
    if (type == "Single") {
      this.bulkeid = false;
      this.singleeid = true;
      this.Reports.Status = "Single";
    } else {
      this.bulkeid = true;
      this.singleeid = false;
      this.Reports.Status = "Bulk";
    }
  }

  formatDateValue(date: Date) {
    const format = "yyyy-MM-dd";
    const locale = "en-US";
    const result = formatDate(date, format, locale);
    return result;
  }
  showPicker(): void {
    this.InitiatedDate.open();
  }
  showEndDatePicker(): void {
    this.endDate.open();
  }

  Clear() {
    //----Reset-----//
    this.Reports.Country = "";
    this.Reports.startDateTime = "";
    this.Reports.EndDate = "";
    this.slectedCallType = [];
    this.selectedLocation = [];
    this.selectedFacilities = [];
    this.Reports.WBSE = "";
    this.Reports.RequestNumber = "";
    this.Reports.eId = "";
    this.Reports.Empno = "";
    this.Reports.AuthStatus = "";
    this.Reports.AuthCode = "";
    this.selectedGateways = [];
    this.selectedProjectNames = [];
    this.Reports.callingPartyNumber = "";
    this.Reports.CallerNo = "";
    this.Reports.CalleeNo = "";
    this.selectedDest = [];
    this.Reports.Event = "";
    this.selectedDailInConff = [];
    this.selectedSMECluster = [];
    this.Reports.SMEName = "";

    this.IsRetriveData = false;
    this.IsDataToExport = false;
    this.loaderGif = false;
    this.rowData = [];
    this.slectedCountries = [];
    this.slectedToCountries = [];
    if (this.SrcDestCountry == true) {
      if (this.divcountryselectType == true) {
        // this.CountryList.value = null;
        this.CountryList = "";
      }
    }
  }

  Reset() {
    this.dlstReportType = "";
    this.Reports.Country = "";
    this.Reports.startDateTime = "";
    this.Reports.EndDate = "";
    this.slectedCallType = [];
    this.selectedLocation = [];
    this.selectedFacilities = [];
    this.Reports.WBSE = "";
    this.Reports.RequestNumber = "";
    this.Reports.eId = "";
    this.Reports.Empno = "";
    this.Reports.AuthStatus = "";
    this.Reports.AuthCode = "";
    this.selectedGateways = [];
    this.selectedProjectNames = [];
    this.Reports.callingPartyNumber = "";
    this.Reports.CallerNo = "";
    this.Reports.CalleeNo = "";
    this.selectedDest = [];
    this.Reports.Event = "";
    this.selectedDailInConff = [];
    this.Reports.SourceCountry = "";
    this.Reports.DestinationCountry = "";
    this.Reports.Location = "";
    this.dynamicVariable = false;
    this.divAuthcode = false;
    this.divFacility = false;
    this.divteamscall1 = false;
    this.divteamscall3 = false;
    this.divConference = false;
    this.diveid = false;
    this.divevent = false;
    this.divcallType = false;
    this.divCommonareaPhone = false;
    this.divGateway = false;
    this.divProjectName = false;
    this.divSourceCountry = false;
    this.divcountrymultiselectType = false;
    this.divDestinationCountry = false;
    this.SrcDestCountry = false;
    this.SrcDestCountry = true;
    this.dynamicVariable = false;
    this.chkCountryReportType = false;
    this.divLocationReport = false;
    //2023 Multiselct filetr for CountrySummary Report
    this.slectedCountries = [];
    this.slectedToCountries = [];
  }

  GreyCallee() {
    this.ReportType = this.dlstReportType;
    const phone = this.Reports.callingPartyNumber;
    if (this.ReportType == "Call Summary Report") {
      if (phone.length > 0) {
        this.divteamscall1 = false;
      } else {
        this.divteamscall1 = true;
      }
    }
  }
  SummaryDeviceTypeEvent() {
    this.DeviceType = this.dlstDeviceType;
    this.DestinationTypeList = [
      { label_id: 0, label: "Local" },
      { label_id: 1, label: "National" },
      { label_id: 2, label: "International" },
      { label_id: 3, label: "Incoming" },
      { label_id: 4, label: "Tollfree" },
    ];

    if (
      this.RoleReport == "Global Admin" ||
      this.RoleReport == "Regional Voice Admin"
    ) {
      this.CAPService.DropdownValues(
        "SummaryReports",
        this.DeviceType
      ).subscribe((data) => {
        this.ReportTypes = data;
      });
    }
    //Resetting with Default Values
    this.Reset();
    this.Clear();
  }

  GreyPhone() {
    this.ReportType = this.dlstReportType;
    const CalleeNo = this.Reports.CalleeNo.toString().trim();
    const CallerNo = this.Reports.CallerNo.toString().trim();
    if (this.ReportType == "Call Summary Report") {
      if (CalleeNo.length > 0 || CallerNo.length > 0) {
        this.divCommonareaPhone = false;
      } else {
        this.divCommonareaPhone = true;
      }
    }
  }

  GetFacility() {
    // this.Reports.Country = this.CountryList.value;
    this.Reports.Country = this.CountryList;
    const MultiProjectObj = { MultiProjectArray: [] };
    const MultiGatewayObj = { MultiGatewayArray: [] };
    const MultiFacilityObj = { MultiFacilityArray: [] };
    const MultiLocationObj = { MultiLocationArray: [] };
    this.selectedLocation = [];
    this.selectedFacilities = [];

    const MultiDailInConferenceObj = { MultiDailInConferenceArray: [] };

    this.DestinationTypeList = [
      { label_id: 0, label: "Local" },
      { label_id: 1, label: "National" },
      { label_id: 2, label: "International" },
      { label_id: 3, label: "Incoming" },
      { label_id: 4, label: "Tollfree" },
    ];

    this.CAPService.FacilityList(this.Reports.Country).subscribe((data) => {
      this.FacilityList = data;
      for (let i = 0; i < data.length; i++) {
        const fac = { label_id: i, label: this.FacilityList[i].Description };
        MultiFacilityObj.MultiFacilityArray.push(fac);
      }
      this.FacilityList = MultiFacilityObj.MultiFacilityArray;
    });
    const CountryValue =
      this.Reports.Country == "All"
        ? "N"
        : this.Reports.Country == ""
        ? "N"
        : this.Reports.Country;
    this.CAPService.GetVoiceAdminDetails(
      null,
      "LocationDropdown",
      CountryValue
    ).subscribe((data) => {
      this.LocationList = data;
      for (let i = 0; i < this.LocationList.length; i++) {
        const Location = { label_id: i, label: this.LocationList[i].Location };

        MultiLocationObj.MultiLocationArray.push(Location);
      }
      this.LocationList = MultiLocationObj.MultiLocationArray;
    });
    this.CAPService.GetVoiceAdminDetails(
      this.DeviceType,
      "Project",
      CountryValue
    ).subscribe((data) => {
      this.ProjectList = data;
      let uniqProjectList = this.ProjectList.map((x) => x.ProjectName);
      uniqProjectList = uniqProjectList.filter(
        (val, index) => uniqProjectList.indexOf(val) == index
      );
      for (let i = 0; i < uniqProjectList.length; i++) {
        const Projects = { label_id: i, label: uniqProjectList[i] };
        MultiProjectObj.MultiProjectArray.push(Projects);
      }
      this.ProjectList = MultiProjectObj.MultiProjectArray;
    });
    //2023 Requirement country removal on Gateway report
    if (this.ReportType != "Gateway Report" && this.DeviceType != "Teams") {
      this.CAPService.GetVoiceAdminDetails(
        this.DeviceType,
        "GatewaysNames",
        CountryValue
      ).subscribe((data) => {
        this.GatewayList = data;
        for (let i = 0; i < data.length; i++) {
          const Gateway = { label_id: i, label: data[i].Name };
          MultiGatewayObj.MultiGatewayArray.push(Gateway);
        }
        this.GatewayList = MultiGatewayObj.MultiGatewayArray;
      });
    }
    // this.CAPService.GetVoiceAdminDetails(this.DeviceType, "DialInConferenceNo", CountryValue).subscribe(data => {
    //   this.DialInConferenceList = data
    //   for (var i = 0; i < data.length; i++) {
    //     var DialInConference = { label_id: i, label: data[i].DailInConferenceNumber }
    //     MultiDailInConferenceObj.MultiDailInConferenceArray.push(DialInConference);
    //   }
    //   this.DialInConferenceList = MultiDailInConferenceObj.MultiDailInConferenceArray;
    // });
  }
  toggleSelection() {
    if (this.IsAuth) {
      this.Reports.AuthCode = null;
    } else {
      this.Reports.fromAuthcode = null;
      this.Reports.toAuthcode = null;
    }
  }

  GetEnterpriseID() {
    if (this.Reports.eId.length >= 3) {
      this.loaderGif = true;
      this.CAPService.GetEnterpriseIDList(this.Reports.eId).subscribe(
        (data) => {
          this.SelectedEnterpriseIDList = data;
          this.loaderGif = false;
        },
        (err) => {
          this.loaderGif = false;
        }
      );
      this.showRecEIdlistbox = true;
    } else {
      this.showRecEIdlistbox = false;
      this.loaderGif = false;
    }
  }

  PostEnterpriseID() {
    this.showRecEIdlistbox = false;
    if (this.SelectedEnterpriseIDInList != "") {
      this.Reports.eId = this.SelectedEnterpriseIDInList[0];
      this.showRecEIdlistbox = false;
      this.loaderGif = false;
    }
  }

  SummaryReportTypeEvent() {
    this.Clear();
    this.ReportType = this.dlstReportType;
    this.DeviceType = this.dlstDeviceType;
    this.dynamicVariable = false;
    //this.CountryList.value= null;
    this.divcountryselectType = true;
    this.divcountrymultiselectType = false;

    if (this.DeviceType == "Teams") {
      this.IsCountryChecked = false;
      switch (this.ReportType) {
        /*2023 Requirement -- removal of Call Summary Report
        case 'Call Summary Report':
          this.divAuthcode = false; this.divFacility = true;
          this.divteamscall1 = true; this.divteamscall3 = false;
          this.divcallType = true; this.divCommonareaPhone = true;
          this.PhoneMessage = "Phone Number"; this.diveid = true; this.divConference = false;
          this.divGateway = false; this.divProjectName = false; this.divevent = true; this.chkCountryReportType = false;
          this.divSourceCountry = false; this.divDestinationCountry = false; this.SrcDestCountry = true; this.divLocationReport = false;
          break;*/
        case "Gateway Report":
          this.divAuthcode = false;
          this.divFacility = false; //2023 Requirement facility Removal from Gateway report
          this.divteamscall1 = false;
          this.divteamscall3 = false;
          this.divcallType = true;
          this.divCommonareaPhone = false;
          this.PhoneMessage = "Phone Number";
          this.diveid = false;
          this.divConference = false;
          this.divGateway = true;
          this.divProjectName = false;
          this.divevent = true;
          this.diveid = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = false; //2023 Requirement Country Removal from Gateway report
          this.divLocationReport = false;
          this.divSMEcluster = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Project / Group Report":
          this.divAuthcode = false;
          this.divFacility = false; // sprint 5 -> Facility false
          this.divteamscall1 = false;
          this.divteamscall3 = false; // sprint 5 ->destination false
          this.divcallType = true;
          this.divCommonareaPhone = false;
          this.PhoneMessage = "Phone Number";
          this.diveid = false;
          this.divConference = false;
          this.divProjectName = true;
          this.divGateway = false;
          this.divevent = true;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = true;
          this.divLocationReport = false;
          this.divSMEcluster = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        /*2023 Requirement -- removal of Common Area Phone Report
          case 'Common Area Phone Report':
          this.divAuthcode = false; this.divFacility = true;
          this.divteamscall1 = false; this.divteamscall3 = true;
          this.divcallType = true; this.divCommonareaPhone = true;
          this.PhoneMessage = "Common Area Phone Number"; this.diveid = true;
          this.divGateway = false; this.divProjectName = false; this.divConference = false;
          this.divevent = true; this.chkCountryReportType = false;
          this.divSourceCountry = false; this.divDestinationCountry = false; this.SrcDestCountry = true; this.divLocationReport = false;
          break;*/
        case "Dial In Conference Call Report":
          this.divAuthcode = false;
          this.divFacility = false;
          this.divteamscall1 = false;
          this.divteamscall3 = true;
          this.divevent = false;
          this.divcallType = true;
          this.divCommonareaPhone = false;
          this.PhoneMessage = "Dial In Conference Call Number";
          this.diveid = false;
          this.divGateway = false;
          this.divProjectName = false;
          this.divConference = true;
          this.divteamscall3 = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = false;
          this.divLocationReport = false;
          this.divSMEcluster = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "User Summary Reports":
          this.divcallType = false;
          this.divFacility = false;
          this.divAuthcode = false;
          this.divGateway = false;
          this.divProjectName = false;
          this.divCommonareaPhone = false;
          this.divteamscall1 = false;
          this.divteamscall3 = false;
          this.diveid = true;
          this.divevent = true;
          this.divConference = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = true;
          this.divLocationReport = false;
          this.divSMEcluster = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Country Summary Report":
          this.divcallType = true;
          this.divFacility = false;
          this.divAuthcode = false;
          this.divGateway = false;
          this.divProjectName = false;
          this.divCommonareaPhone = false;
          this.divteamscall1 = false;
          this.divteamscall3 = false;
          this.diveid = false;
          this.divevent = true;
          this.divConference = false;
          this.chkCountryReportType = true;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = true;
          this.divLocationReport = false;
          this.divcountrymultiselectType = true;
          this.divcountryselectType = false;
          this.MultiCountrySummaryFlag = true;
          this.CountrySummaryFlag = false;
          this.divSMEcluster = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "Location Summary Report":
          this.divcallType = true;
          this.divFacility = false;
          this.divAuthcode = false;
          this.divGateway = false;
          this.divProjectName = false;
          this.divCommonareaPhone = false;
          this.divteamscall1 = false;
          this.divteamscall3 = false;
          this.diveid = false;
          this.divevent = true;
          this.divConference = false;
          this.chkCountryReportType = false;
          this.divSourceCountry = false;
          this.divDestinationCountry = false;
          this.SrcDestCountry = true;
          this.divLocationReport = true;
          this.divSMEcluster = false;
          this.singleeid = false;
          this.bulkeid = false;

          break;
      }
    } else {
      switch (this.ReportType) {
        case "Authcode Mapping Report":
          this.divAuthcode = true;
          this.divFacility = true;
          this.divcallType = false;
          this.divCommonareaPhone = false;
          this.divteamscall1 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.divGateway = false;
          this.divevent = false;
          this.diveid = false;
          this.divevent = false;
          this.divSMEcluster = false;
          this.singleeid = false;
          this.bulkeid = false;
          break;
        case "SME Cluster Utilization Report":
          this.divAuthcode = false;
          this.divFacility = false;
          this.divcallType = false;
          this.divCommonareaPhone = false;
          this.divteamscall1 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.divGateway = false;
          this.divevent = false;
          this.diveid = false;
          this.divevent = false;
          this.singleeid = false;
          this.bulkeid = false;
          this.divSMEcluster = true;
          this.divcountrymultiselectType = true;
          this.divcountryselectType = false;
          break;
        default:
          this.divAuthcode = false;
          this.divFacility = false;
          this.divteamscall1 = false;
          this.divteamscall3 = false;
          this.divConference = false;
          this.diveid = false;
          this.divevent = false;
          this.divcallType = false;
          this.divCommonareaPhone = false;
          this.divGateway = false;
          this.divProjectName = false;
          this.divSMEcluster = false;
          this.singleeid = false;
          this.bulkeid = false;
      }
    }
    this.DestinationTypeList = [
      { label_id: 0, label: "Local" },
      { label_id: 1, label: "National" },
      { label_id: 2, label: "International" },
      { label_id: 3, label: "Incoming" },
      { label_id: 4, label: "Tollfree" },
    ];

    this.SMENameList = [
      { label_id: 0, label: "APA" },
      { label_id: 1, label: "AMR" },
      { label_id: 2, label: "EMEA" },
    ];

    if (this.ReportType == "Dial In Conference Call Report") {
      this.CAPService.DropdownValues("CallTypeDIC", "Teams").subscribe(
        (data) => {
          this.CallTypeListTeams = data;
          const MultiCallTypeObj = { MultiCallTypeArray: [] };
          for (let i = 0; i < data.length; i++) {
            const CallType = { label_id: i, label: data[i].Value };
            MultiCallTypeObj.MultiCallTypeArray.push(CallType);
          }
          this.CallTypeListTeams = MultiCallTypeObj.MultiCallTypeArray;
        }
      );
      const MultiDailInConferenceObj = { MultiDailInConferenceArray: [] };
      this.CAPService.GetVoiceAdminDetails(
        this.DeviceType,
        "DialInConferenceNo",
        null
      ).subscribe((data) => {
        this.DialInConferenceList = data;
        for (let i = 0; i < data.length; i++) {
          if (data[i].CityName == null || data[i].CityName == "") {
            var DialInConference = {
              label_id: i,
              label: data[i].DailInConferenceNumber + " - " + data[i].country,
            };
          } else {
            var DialInConference = {
              label_id: i,
              label:
                data[i].DailInConferenceNumber +
                " - " +
                data[i].country +
                " - " +
                data[i].CityName,
            };
          }
          MultiDailInConferenceObj.MultiDailInConferenceArray.push(
            DialInConference
          );
        }
        this.DialInConferenceList =
          MultiDailInConferenceObj.MultiDailInConferenceArray;
      });
    } else {
      this.CAPService.DropdownValues("CallType", "Teams").subscribe((data) => {
        this.CallTypeListTeams = data;
        const MultiCallTypeObj = { MultiCallTypeArray: [] };
        for (let i = 0; i < data.length; i++) {
          const CallType = { label_id: i, label: data[i].Value };
          MultiCallTypeObj.MultiCallTypeArray.push(CallType);
        }
        this.CallTypeListTeams = MultiCallTypeObj.MultiCallTypeArray;
      });
    }
    //2023 Requirement country removal on Gateway report
    const MultiGatewayObj = { MultiGatewayArray: [] };
    if (this.DeviceType == "Teams" && this.ReportType == "Gateway Report") {
      this.CAPService.GetVoiceAdminDetails(
        this.DeviceType,
        "GatewaysNames",
        ""
      ).subscribe((data) => {
        this.GatewayList = data;
        for (let i = 0; i < data.length; i++) {
          const Gateway = { label_id: i, label: data[i].Name };
          MultiGatewayObj.MultiGatewayArray.push(Gateway);
        }
        this.GatewayList = MultiGatewayObj.MultiGatewayArray;
      });
    }
    // 2023 sprint 3 changes for India Server
    if (
      this.DeviceType == "Teams" &&
      this.href == "https://mycalls-india.accenture.com/SummaryReports"
    ) {
      alert(
        "Teams report is not available for India. Please reach out to India voice team for any queries."
      );
    }
  }

  ExportToExcel() {
    this.loaderGif = true;
    const ReportName = this.dlstReportType + ".xlsx";
    if (this.DeviceType == "Teams") {
      let filter = null;
      /*2023 Requirement -- removal of Call Summary Report
      if (this.ReportType == "Call Summary Report") {
        filter = [{
          "Device Type": this.DeviceType, "Report Type": this.ReportType, "Start Date": this.Reports.startDateTime, "End Date": this.Reports.EndDate, "User Country": this.Reports.Country,
          "Call Type": this.Reports.callType, Facility: this.Reports.Facility, "Phone Number": this.Reports.callingPartyNumber, "Caller Number": this.Reports.CallerNo, "Callee Number": this.Reports.CalleeNo,
          "Enterprise ID": this.Reports.eId, "Event Type": this.Reports.Event
        }];
      }
      */
      if (this.ReportType == "Gateway Report") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "Call Type": this.Reports.callType,
            Facility: this.Reports.Facility,
            "Gateway Name": this.Reports.toGateway,
            "Destination Type": this.Reports.Destination,
            "Event Type": this.Reports.Event,
          },
        ];
      }
      //sprint5 -> Facility Destination type removal
      else if (this.ReportType == "Project / Group Report") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "Call Type": this.Reports.callType,
            "Project / Group Name": this.Reports.ProjectName,
            "Event Type": this.Reports.Event,
          },
        ];
      } else if (this.ReportType == "Dial In Conference Call Report") {
        /*2023 Requirement -- removal of Common Area Phone Report
      else if (this.ReportType == "Common Area Phone Report") {
        filter = [{
          "Device Type": this.DeviceType, "Report Type": this.ReportType, "Start Date": this.Reports.startDateTime, "End Date": this.Reports.EndDate, "User Country": this.Reports.Country,
          "Call Type": this.Reports.callType, Facility: this.Reports.Facility, "Common Area Phone Number": this.Reports.callingPartyNumber, "Destination Type": this.Reports.Destination,
          "Enterprise ID": this.Reports.eId, "Event Type": this.Reports.Event
        }];
      }*/
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "Event Type": this.Reports.Event,
            "Dial In Conference Call Number": this.Reports.DailInConference,
          },
        ];
      } else if (this.ReportType == "User Summary Reports") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "Enterprise ID": this.Reports.eId,
            "Event Type": this.Reports.Event,
          },
        ];
      } else if (this.ReportType == "Country Summary Report") {
        if (this.IsCountryChecked) {
          filter = [
            {
              "Device Type": this.DeviceType,
              "Report Type": this.ReportType,
              "Start Date": this.Reports.startDateTime,
              "End Date": this.Reports.EndDate,
              "From Country": this.Reports.SourceCountry,
              "To Country": this.Reports.DestinationCountry,
              "Call Type": this.Reports.callType,
              "Event Type": this.Reports.Event,
            },
          ];
        } else {
          filter = [
            {
              "Device Type": this.DeviceType,
              "Report Type": this.ReportType,
              "Start Date": this.Reports.startDateTime,
              "End Date": this.Reports.EndDate,
              "User Country": this.Reports.Country,
              "Call Type": this.Reports.callType,
              "Event Type": this.Reports.Event,
            },
          ];
        }
      } else if (this.ReportType == "Location Summary Report") {
        filter = [
          {
            "Device Type": this.DeviceType,
            "Report Type": this.ReportType,
            "Start Date": this.Reports.startDateTime,
            "End Date": this.Reports.EndDate,
            "User Country": this.Reports.Country,
            "User Location": this.Reports.Location,
            "Call Type": this.Reports.callType,
            "Event Type": this.Reports.Event,
          },
        ];
      }

      const opts = [
        { sheetid: "Filters", header: true },
        { sheetid: "Data", header: true },
      ];
      // alasql.default('SELECT INTO XLSX("' + ReportName + '",?) FROM ?', [
      //   opts,
      //   [filter, this.rowData],
      // ]);
      this.loaderGif = false;
    } else {
      // alasql.default(
      //   'SELECT INTO XLSX("' + ReportName + '", {headers:true}) FROM ?',
      //   [this.rowData]
      // );
      // this.loaderGif = false;
    }
    this.loaderGif = false;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.setDomLayout("autoHeight");
    this.gridColumnApi = params.columnApi;
  }
  //2023 requirement Bulk upload feature for user suummary report instead of 5 userid search
  EnterpriseMember() {
    const i = this.Reports.eId;
    const keywordsArr = i.split(",");
    if (keywordsArr.length > 5) {
      alert("Only 5 or less Enterprise Id's are allowed");
    }
  }

  CountryReportType() {
    if (this.IsCountryChecked) {
      this.Reports.SourceCountry = "";
      this.Reports.DestinationCountry = "";
      this.Reports.Country = "";
      this.slectedCallType = [];

      this.SrcDestCountry = false;
      this.divSourceCountry = true;
      this.divDestinationCountry = true;
      this.dynamicVariable = true;
      this.divcountrymultiselectType = false;

      this.IsRetriveData = false;
      this.IsDataToExport = false;
      this.loaderGif = false;
      this.slectedCountries = [];
      this.slectedToCountries = [];
      if ((this.ReportType = "Country Summary Report")) {
        this.MultiCountrySummaryFlag = true;
        this.CountrySummaryFlag = false;
      } else {
        this.MultiCountrySummaryFlag = false;
        this.CountrySummaryFlag = true;
      }
    } else {
      this.Reports.SourceCountry = "";
      this.Reports.DestinationCountry = "";
      this.Reports.Country = "";
      this.slectedCallType = [];
      this.slectedCountries = [];
      this.slectedToCountries = [];

      this.divSourceCountry = false;
      this.SrcDestCountry = true;
      this.divDestinationCountry = false;
      this.MultiCountrySummaryFlag = false;
      this.CountrySummaryFlag = true;
      if ((this.ReportType = "Country Summary Report")) {
        this.divcountrymultiselectType = true;
        this.divcountryselectType = false;
      } else {
        this.divcountrymultiselectType = false;
        this.divcountryselectType = true;
      }

      this.dynamicVariable = false;

      //this.IsRetriveData = false;
      this.IsDataToExport = false;
      this.loaderGif = false;
    }
  }
  gridSummaryLoad() {
    const randomRefresh = Date.now();
    let message = "";
    function validateAlpaNumeric(txtPhone) {
      const filter = /^$|^[A-Za-z0-9]+$/;
      if (filter.test(txtPhone)) {
        return true;
      } else {
        return false;
      }
    }
    function validateNumber(txtPhone) {
      //var filter = /^[0-9]+$/;
      const filter = /^[0-9]+/;
      if (filter.test(txtPhone)) {
        return true;
      } else {
        return false;
      }
    }
    function validatePhone(txtPhone) {
      const filter = /^[0-9-+]+$/;
      if (filter.test(txtPhone)) {
        return true;
      } else {
        return false;
      }
    }
    if (this.dlstDeviceType == "") {
      message = "Please Select Device Type";
    }
    if (this.dlstReportType == "") {
      message = message + "\n" + "Please Select Report Type";
    }
    if (this.Reports.startDateTime == "") {
      message = message + "\n" + "Please Select Start Date";
    }
    if (this.Reports.EndDate == "") {
      message = message + "\n" + "Please Select End Date";
    }
    if (this.IsCountryChecked) {
      //2023 Country Summary Report
      if (this.ReportType == "Country Summary Report") {
        if (this.Reports.SourceCountry == "") {
          message = message + "\n" + "Please Select From Country";
        }
        if (this.slectedToCountries.length == 0) {
          message = message + "\n" + "Please Select To Country";
        }
      } else {
        if (this.Reports.SourceCountry == "") {
          message = message + "\n" + "Please Select From Country";
        }
        if (this.Reports.DestinationCountry == "") {
          message = message + "\n" + "Please Select To Country";
        }
      }
    } else if (
      this.ReportType != "Dial In Conference Call Report" &&
      this.ReportType != "Gateway Report"
    ) {
      if (
        this.ReportType == "Country Summary Report" ||
        this.ReportType == "SME Cluster Utilization Report"
      ) {
        if (this.slectedCountries.length == 0)
          message = message + "\n" + "Please Select Country";
      } else if (this.Reports.Country == "" || this.Reports.Country == null) {
        message = message + "\n" + "Please Select Country";
      }
    }
    if (this.ReportType == "SME Cluster Utilization Report") {
      if (this.selectedSMECluster.length == 0) {
        message = message + "\n" + "Please Select SME Name";
      }
    }
    if (this.Reports.callingPartyNumber != "") {
      if (validatePhone(this.Reports.callingPartyNumber)) {
      } else {
        if (this.ReportType == "Common Area Phone Report") {
          message =
            message +
            "\n" +
            "Please Enter Numeric in Common Area Phone Number ";
        } else if (this.ReportType == "Dial In Conference Call Report") {
          message = message + "\n" + "Please Enter Numeric in Dial in Number";
        } else {
          message = message + "\n" + "Please Enter Numeric in Phone Number ";
        }
      }
    }
    if (this.Reports.CallerNo != "") {
      if (validatePhone(this.Reports.CallerNo)) {
      } else {
        message = message + "\n" + "Please Enter Numeric in Caller Number";
      }
    }
    if (this.Reports.CalleeNo != "") {
      if (validatePhone(this.Reports.CalleeNo)) {
      } else {
        message = message + "\n" + "Please Enter Numeric in Callee Number";
      }
    }
    // Validation for WBSE,AuthCode,Request Number;

    if (this.Reports.WBSE != "") {
      if (validateAlpaNumeric(this.Reports.WBSE)) {
      } else {
        message = message + "\n" + "Please Enter Valid WBS";
      }
    }
    if (this.Reports.RequestNumber != "") {
      if (validateAlpaNumeric("txtRequestNumber")) {
      } else {
        message = message + "\n" + "Please Enter Valid Request Number";
      }
    }
    if (this.Reports.AuthCode) {
      if (validateNumber(this.Reports.AuthCode)) {
      } else {
        message = message + "\n" + "Please Enter Valid AuthCode";
      }
    }
    if (this.Reports.Empno != "") {
      if (validateNumber(this.Reports.Empno)) {
      } else {
        message = message + "\n" + "Please Enter Valid Employee Number";
      }
    }
    if (
      this.dlstReportType == "Call Summary Report" ||
      this.dlstReportType == "User Summary Reports" ||
      this.dlstReportType == "Common Area Phone Report"
    ) {
      const eid = this.Reports.eId;
      const keywordsArr = eid.split(",");

      if (keywordsArr.length > 5) {
        message =
          message + "\n" + "Please Enter Only 5 or less Enterprise Id's";
      }
    }

    if (message != "") {
      alert(message);
    } else {
      this.ReportType = this.dlstReportType;
      switch (this.ReportType) {
        case "Call Charge":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          } else {
            this.Type = "CallCharge";
          }
          break;
        /*2023 Requirement -- removal of Call Summary Report 
        case 'Call Summary Report':
          if (this.dlstDeviceType == 'Teams') {
            this.Type = 'CallChargeTeams';
          }
          break;*/
        case "Project / Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GroupReportTeams";
          }
          break;
        case "Trunk Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "TrunkGroupReportTeams";
          } else {
            this.Type = "TrunkGroupReport";
          }
          break;
        case "Gateway Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GatewayReportTeams";
          } else {
            this.Type = "GatewayReport";
          }
          break;
        case "Country Wise Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CountryWiseReportTeams";
          } else {
            this.Type = "CountryWiseReport";
          }
          break;
        case "Dial In Calls Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "DialInCallsReportsTeams";
          } else {
            this.Type = "DialInCallsReports";
          }
          break;
        case "Authcode Mapping Report":
          this.Type = "AuthcodeMappingReport";
          break;
        case "Invalid WBSE Report":
          this.Type = "InvalidWBSEReport";
          break;
        /*2023 Requirement -- removal of Common Area Phone Report 
        case 'Common Area Phone Report':
          if (this.dlstDeviceType == 'Teams') {
            this.Type = 'CommonAreaPhoneReportTeams';
          }
          break;*/
        case "Dial In Conference Call Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "DialInConferenceCallTeams";
          }
          break;
        case "User Summary Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "UserSummaryReports";
          }
          break;
        case "Country Summary Report":
          if (this.dlstDeviceType == "Teams") {
            if (this.IsCountryChecked) {
              this.Type = "CountrySummaryReportTeamsChecked";
            } else {
              this.Type = "CountrySummaryReportTeams";
            }
          }
          break;
        case "Location Summary Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "LocationSummaryReportTeams";
          }
          break;
        case "SME Cluster Utilization Report":
          this.Type = "SMEClusterUtilization";
          break;
      }
      const concString = "";
      let Project = "";
      let GatewayNames = "";
      const Telco = "";
      let FacilityNames = "";
      let calltypeNames = "";
      let destinationtypeNames = "";
      let DailInConfNo = "";
      let LocationNames = "";
      let SMEClusterName = "";

      for (var i = 0; i < this.selectedProjectNames.length; i++) {
        Project = Project + "," + this.selectedProjectNames[i].label;
      }
      for (var i = 0; i < this.selectedGateways.length; i++) {
        GatewayNames = GatewayNames + "," + this.selectedGateways[i].label;
      }
      for (var i = 0; i < this.slectedCallType.length; i++) {
        calltypeNames = calltypeNames + "," + this.slectedCallType[i].label;
      }
      for (var i = 0; i < this.selectedFacilities.length; i++) {
        FacilityNames = FacilityNames + "~" + this.selectedFacilities[i].label;
      }
      for (var i = 0; i < this.selectedLocation.length; i++) {
        LocationNames = LocationNames + "," + this.selectedLocation[i].label;
      }
      this.Reports.Location = LocationNames.slice(1, LocationNames.length);
      for (var i = 0; i < this.selectedDest.length; i++) {
        //destinationtypeNames = destinationtypeNames + ',' + this.selectedDest[i].label + ' Calls';
        destinationtypeNames =
          destinationtypeNames + "," + this.selectedDest[i].label;
      }
      for (var i = 0; i < this.selectedDailInConff.length; i++) {
        //var res = this.selectedDailInConff[i].label.replace("+", "");
        DailInConfNo = DailInConfNo + "," + this.selectedDailInConff[i].label;
        //DailInConfNo = DailInConfNo + ',' + res
      }
      if (this.ReportType == "SME Cluster Utilization Report") {
        for (var i = 0; i < this.selectedSMECluster.length; i++) {
          SMEClusterName =
            SMEClusterName + "," + this.selectedSMECluster[i].label;
        }
        this.Reports.SMEName = SMEClusterName.slice(1, SMEClusterName.length);

        var countrySummaryCountry = "";
        for (var i = 0; i < this.slectedCountries.length; i++) {
          countrySummaryCountry =
            countrySummaryCountry + "," + this.slectedCountries[i].label;
        }
        this.Reports.Country = countrySummaryCountry.slice(
          1,
          countrySummaryCountry.length
        );
      }

      this.Reports.Destination = destinationtypeNames.slice(
        1,
        destinationtypeNames.length
      );
      //this.Reports.destDeviceName = concString.slice(1, concString.length);
      this.Reports.ProjectName = Project.slice(1, Project.length);
      this.Reports.toGateway = GatewayNames.slice(1, GatewayNames.length);
      //this.Reports.telcoName = Telco.slice(1, Telco.length);;
      //this.Reports.ProjectLead = this.LoginEnterpriseID;
      this.Reports.Facility = FacilityNames.slice(1, FacilityNames.length);
      this.Reports.callType = calltypeNames.slice(1, calltypeNames.length);
      this.Reports.DailInConference = DailInConfNo.slice(
        1,
        DailInConfNo.length
      );
      if (this.ReportType == "Dial In Conference Call Report") {
        this.Reports.Facility = DailInConfNo.slice(1, DailInConfNo.length);
      }
      // 2023 Country Summary Report
      if (this.ReportType == "Country Summary Report") {
        if (this.IsCountryChecked) {
          let countrySummaryToCountry = "";

          for (var i = 0; i < this.slectedToCountries.length; i++) {
            countrySummaryToCountry =
              countrySummaryToCountry + "," + this.slectedToCountries[i].label;
          }

          this.Reports.DestinationCountry = countrySummaryToCountry.slice(
            1,
            countrySummaryToCountry.length
          );
        } else {
          var countrySummaryCountry = "";
          for (var i = 0; i < this.slectedCountries.length; i++) {
            countrySummaryCountry =
              countrySummaryCountry + "," + this.slectedCountries[i].label;
          }
          this.Reports.Country = countrySummaryCountry.slice(
            1,
            countrySummaryCountry.length
          );
        }
      }

      //2023 requirement Bulk upload feature for user summary report instead of 5 userid search
      this.Reports.BulkUploadUserId = "";
      if (this.bulkFile != "" && this.bulkFile != undefined && this.diveid) {
        this.loaderGif = true;
        this.TempUserKey = "";
        const file = this.summaryReportFG.controls.inputFile.value;
        const ext = file.split(".").pop().toLowerCase();
        if (file == "") {
          alert("Please Upload The Template");
          this.loaderGif = false;
          return;
        }
        if (ext != "xls" && ext != "xlsx") {
          alert(
            "Please upload only Excel file with .xls or .xlsx extension only"
          );
          $("#fileControl").val("");
          this.loaderGif = false;
        } else {
          const formData = new FormData();
          formData.append("file", this.bulkFile);
          this.CAPService.UploadBulkEidTemplate(
            this.LoginEnterpriseID,
            formData
          ).subscribe((data) => {
            this.BulkUploaddata = data;
            //this.summaryReportFG.controls.inputFile.setValue('');
            this.TempUserKey = this.BulkUploaddata.TempUserName;
            if (this.TempUserKey != "") {
              this.Reports.BulkUploadUserId = this.TempUserKey;
              this.getPage(1, 10, null);
            } else {
              this.loaderGif = false;
              alert(this.BulkUploaddata.StrMessage);
            }
          });
        }
      } else {
        this.Reports.BulkUploadUserId = this.Reports.eId;
        this.getPage(1, 10, null);
      }
    }
  }
  getPage(curPage, pageSize, sort) {
    const route = "";
    const randomRefresh = Date.now();
    this.loaderGif = true;
    this.CAPService.GetSummaryReportDetails(
      this.Reports,
      this.Type,
      this.formatDateValue(this.Reports.startDateTime),
      this.formatDateValue(this.Reports.EndDate)
    ).subscribe((data) => {
      if (this.DeviceType == "Teams") {
        if (this.ReportType == "Gateway Report") {
          this.columnDefs = [
            {
              headerName: "Gateway",
              field: "Gateway",
              filter: true,
              sortable: true,
              width: 280,
            },
            {
              headerName: "Total Incoming Calls",
              field: "Total Incoming Calls",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Outgoing Calls",
              field: "Total Outgoing Calls",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Incoming Duration In Minutes",
              field: "Total Incoming Duration In Minutes",
              filter: true,
              sortable: true,
              width: 260,
            },
            {
              headerName: "Total Outgoing Duration In Minutes",
              field: "Total Outgoing Duration In Minutes",
              filter: true,
              sortable: true,
              width: 210,
            },
            {
              headerName: "Total Call Cost",
              field: "Total Cost",
              filter: true,
              sortable: true,
              width: 300,
            },
          ];
          // { headerName: 'Display Name', field: 'Display Name', filter: true, sortable: true },
          // { headerName: 'SIP Address', field: 'SIP Address', filter: true, sortable: true },
          // { headerName: 'Caller Number', field: 'Caller Number', filter: true, sortable: true },
          // { headerName: 'Callee Number', field: 'Callee Number', filter: true, sortable: true },
          // { headerName: 'Start Time', field: 'Start Time', filter: true, sortable: true },
          // { headerName: 'End Time', field: 'End Time', filter: true, sortable: true },
          // { headerName: 'Invite Time', field: 'Invite Time', filter: true, sortable: true },
          // { headerName: 'Failure Time', field: 'Failure Time', filter: true, sortable: true },
          // { headerName: 'User Country', field: 'User Country', filter: true, sortable: true },
          // { headerName: 'Destination Type', field: 'Destination Type', filter: true, sortable: true },
          // { headerName: 'Call Type', field: 'callType', filter: true, sortable: true },
          // { headerName: 'Gateway', field: 'Gateway', filter: true, sortable: true },
          // { headerName: 'Count', field: 'Count', filter: true, sortable: true },
          // { headerName: 'Total Count', field: 'Total Count', filter: true, sortable: true },
          // { headerName: 'Cost', field: 'Cost', filter: true, sortable: true }
          //{ headerName: 'Total Cost', field: 'Total Cost', filter: true, sortable:true }
        }
        // sprint 5 -grid columns
        else if (this.ReportType == "Project / Group Report") {
          this.columnDefs = [
            {
              headerName: "User Country",
              field: "User Country",
              filter: true,
              sortable: true,
              width: 275,
            },
            {
              headerName: "Total Incoming Calls",
              field: "Total Incoming Calls",
              filter: true,
              sortable: true,
              width: 205,
            },
            {
              headerName: "Total Outgoing Calls",
              field: "Total Outgoing Calls",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Incoming Duration In Minutes",
              field: "Total Incoming Duration In Minutes",
              filter: true,
              sortable: true,
              width: 260,
            },
            {
              headerName: "Total Outgoing Duration In Minutes",
              field: "Total Outgoing Duration In Minutes",
              filter: true,
              sortable: true,
              width: 210,
            },
            {
              headerName: "Total Call Cost",
              field: "Total Cost",
              filter: true,
              sortable: true,
              width: 295,
            },
          ];
          // { headerName: 'Display Name', field: 'Display Name', filter: true, sortable: true },
          // { headerName: 'SIP Address', field: 'SIP Address', filter: true, sortable: true },
          // { headerName: 'Caller Number', field: 'Caller Number', filter: true, sortable: true },
          // { headerName: 'Callee Number', field: 'Callee Number', filter: true, sortable: true },
          // { headerName: 'Start Time', field: 'Start Time', filter: true, sortable: true },
          // { headerName: 'End Time', field: 'End Time', filter: true, sortable: true },
          // { headerName: 'Invite Time', field: 'Invite Time', filter: true, sortable: true },
          // { headerName: 'Failure Time', field: 'Failure Time', filter: true, sortable: true },
          // { headerName: 'Destination Type', field: 'Destination Type', filter: true, sortable: true },
          // { headerName: 'Call Type', field: 'callType', filter: true, sortable: true },
          // { headerName: 'Project / Group Name', field: 'Project / Group Name', filter: true, sortable: true },
          // { headerName: 'Count', field: 'Count', filter: true, sortable: true },
          // { headerName: 'Total Count', field: 'Total Count', filter: true, sortable: true },
          // { headerName: 'Cost', field: 'Cost',filter: true, sortable: true },
          // { headerName: 'Total Cost', field: 'Total Cost', sortable: true, filter: true }
        } else if (this.ReportType == "User Summary Reports") {
          this.columnDefs = [
            {
              headerName: "Display Name",
              field: "DisplayName",
              filter: true,
              sortable: true,
            },
            {
              headerName: "SIP Address",
              field: "SIP Address",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Country",
              field: "Country",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Incoming Calls",
              field: "incomingCalls",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Outgoing Calls",
              field: "outgoingCalls",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Incoming Duration In Minutes",
              field: "incomingDurationInMinutes",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Outgoing Duration In Minutes",
              field: "outgoingDurationInMinutes",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Total Cost",
              field: "TotalCost",
              filter: true,
              sortable: true,
            },
          ];
        } else if (this.ReportType == "Dial In Conference Call Report") {
          this.columnDefs = [
            {
              headerName: "Country",
              field: "Country",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Dial In Conference Number",
              field: "Dial In Conference Number",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Number of Incoming Calls",
              field: "Total Number of Incoming Calls",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Number of Outgoing Calls",
              field: "Total Number of Outgoing Calls",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Incoming Duration In Minutes",
              field: "Total Incoming Duration In Minutes",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Outgoing Duration In Minutes",
              field: "Total Outgoing Duration In Minutes",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Cost",
              field: "Total Cost",
              filter: true,
              sortable: true,
            },
          ];
        } else if (this.ReportType == "Country Summary Report") {
          if (this.Type == "CountrySummaryReportTeams") {
            this.columnDefs = [
              {
                headerName: "User Country",
                field: "User Country",
                filter: true,
                sortable: true,
                width: 185,
              },
              {
                headerName: "Total Incoming Calls",
                field: "Total Incoming Calls",
                filter: true,
                sortable: true,
                width: 200,
              },
              {
                headerName: "Total Outgoing Calls",
                field: "Total Outgoing Calls",
                filter: true,
                sortable: true,
                width: 200,
              },
              {
                headerName: "Total Incoming Duration In Minutes",
                field: "Total Incoming Duration In Minutes",
                filter: true,
                sortable: true,
                width: 200,
              },
              {
                headerName: "Total Outgoing Duration In Minutes",
                field: "Total Outgoing Duration In Minutes",
                filter: true,
                sortable: true,
                width: 200,
              },
              {
                headerName: "Total Call Cost",
                field: "Total Cost",
                filter: true,
                sortable: true,
                width: 185,
              },
            ];
          } else {
            this.columnDefs = [
              {
                headerName: "Source Country",
                field: "Source Country",
                filter: true,
                sortable: true,
                width: 250,
              },
              {
                headerName: "Destination Country",
                field: "Destination Country",
                filter: true,
                sortable: true,
                width: 250,
              },
              {
                headerName: "Total Calls",
                field: "Total Calls",
                filter: true,
                sortable: true,
                width: 250,
              },
              {
                headerName: "Total Call Duration In Minutes",
                field: "Total Call Duration In Minutes",
                filter: true,
                sortable: true,
                width: 250,
              },
              {
                headerName: "Total Call Cost",
                field: "Total Cost",
                filter: true,
                sortable: true,
                width: 250,
              },
            ];
          }
        } else if (this.ReportType == "Location Summary Report") {
          this.columnDefs = [
            {
              headerName: "User Country",
              field: "User Country",
              filter: true,
              sortable: true,
              width: 185,
            },
            {
              headerName: "User Location",
              field: "User Location",
              filter: true,
              sortable: true,
              width: 185,
            },
            {
              headerName: "Total Incoming Calls",
              field: "Total Incoming Calls",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Outgoing Calls",
              field: "Total Outgoing Calls",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Incoming Duration In Minutes",
              field: "Total Incoming Duration In Minutes",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Outgoing Duration In Minutes",
              field: "Total Outgoing Duration In Minutes",
              filter: true,
              sortable: true,
              width: 200,
            },
            {
              headerName: "Total Call Cost",
              field: "Total Cost",
              filter: true,
              sortable: true,
              width: 185,
            },
          ];
        } else {
          this.columnDefs = [
            {
              headerName: "Display Name",
              field: "Display Name",
              filter: true,
              sortable: true,
            },
            {
              headerName: "SIP Address",
              field: "SIP Address",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Caller Number",
              field: "Caller Number",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Callee Number",
              field: "Callee Number",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Start Time",
              field: "Start Time",
              filter: true,
              sortable: true,
            },
            {
              headerName: "End Time",
              field: "End Time",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Invite Time",
              field: "Invite Time",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Failure Time",
              field: "Failure Time",
              filter: true,
              sortable: true,
            },
            {
              headerName: "User Country",
              field: "User Country",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Destination Type",
              field: "Destination Type",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Call Type",
              field: "callType",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Count",
              field: "SIP Address",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Total Count",
              field: "Total Count",
              filter: true,
              sortable: true,
            },
            { headerName: "Cost", field: "Cost", filter: true, sortable: true },
            { headerName: "Total Cost", field: "Total Cost", filter: true },
          ];
        }
      } else if (this.DeviceType == "Cisco") {
        if (this.ReportType == "Authcode Mapping Report") {
          this.columnDefs = [
            {
              headerName: "Request Number",
              field: "Request Number",
              filter: true,
              sortable: true,
            },
            {
              headerName: "User ID",
              field: "User ID",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Employee ID",
              field: "Employee ID",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Supervisor",
              field: "Supervisor",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Status",
              field: "Status",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Location",
              field: "Location",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Country",
              field: "Country",
              filter: true,
              sortable: true,
            },
            {
              headerName: "AuthCode",
              field: "AuthCode",
              filter: true,
              sortable: true,
            },
            {
              headerName: "AuthCode Status",
              field: "AuthCode Status",
              filter: true,
              sortable: true,
            },
            {
              headerName: "From Date",
              field: "From Date",
              filter: true,
              sortable: true,
            },
            {
              headerName: "To Date",
              field: "To Date",
              filter: true,
              sortable: true,
            },
            { headerName: "WBSE", field: "WBSE", filter: true, sortable: true },
            {
              headerName: "Activated On",
              field: "Activated On",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Activated By",
              field: "Activated By",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Deactivated On",
              field: "Deactivated On",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Deactivated By",
              field: "Deactivated By",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Business Reason",
              field: "Business Reason",
              filter: true,
              sortable: true,
            },
          ];
        }
        if (this.ReportType == "Invalid WBSE Report") {
          this.columnDefs = [
            {
              headerName: "ActivateEngineerId",
              field: "ActivateEngineerId",
              filter: true,
              sortable: true,
              width: 300,
            },
            {
              headerName: "Supervisor",
              field: "Supervisor",
              filter: true,
              sortable: true,
              width: 300,
            },
            {
              headerName: "AuthCodeID",
              field: "authCodeId",
              filter: true,
              sortable: true,
              width: 300,
            },
            {
              headerName: "EnterpriseID",
              field: "eId",
              filter: true,
              sortable: true,
              width: 300,
            },
          ];
        }
        if (this.ReportType == "SME Cluster Utilization Report") {
          this.columnDefs = [
            { headerName: "Country", field: "Country" },
            {
              headerName: "Total Number of Calls",
              field: "Total Number of calls",
            },
            {
              headerName: "Total Incoming Calls",
              field: "Total Incoming Calls",
            },
            {
              headerName: "Total Outgoing Calls",
              field: "Total Outgoing Calls",
            },
            {
              headerName: "Total Duration of the Incoming Calls",
              field: "Total Duration of the Incoming Calls",
            },
            {
              headerName: "Total Duration of the Outgoing Calls",
              field: "Total Duration of the Outgoing Calls",
            },
            { headerName: "Trunk Name", field: "Trunk" },
            { headerName: "SME Name", field: "SME Name" },
          ];
        }
      }
      this.excelStyles = [
        {
          id: "darkGreyBackground",
          interior: {
            color: "#888888",
            pattern: "Solid",
          },
          font: {
            fontName: "Calibri Light",
            color: "#ffffff",
          },
        },
      ];
      if (this.DeviceType == "Teams") {
        this.gridOptions = {
          defaultColDef: {
            resizable: true,
            width: 150,
            sortable:true,
            filter: true,
          },
          columnDefs: this.columnDefs,
          pagination: true,
          animateRows: true,
          paginationPageSize: 5,
          getRowStyle: function (params) {
            //Req - 2023 - Logic to check for the last index and modify the font style
            if (
              params.node.rowIndex ===
              params.api.getModel().getRowCount()-1
            ) {
              return { "font-weight": "bold" };
            }
            if (params.node.rowIndex % 2 === 0) {
              return { background: "#FAFAFA" };
            } else {
              return { background: "#E5E5E5" };
            }
          },
        };
        // $('#dataGrid').addClass("table-teams");
      } else {
        this.gridOptions = {
          defaultColDef: {
            resizable: true,
            width: 150,
          },
          columnDefs: this.columnDefs,
          pagination: true,
          animateRows: true,
          paginationPageSize: 5,
          getRowStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              return { background: "#FAFAFA" };
            } else {
              return { background: "#E5E5E5" };
            }
          },
        };
        // if($('#dataGrid')[0].classList.value === "table-teams"){
        //   $('#dataGrid').removeClass("table-teams");
        // }
      }

      this.rowData = data;
      //sprint 5

      if (this.rowData.toString() == "Please Enter valid User EnterpriseID") {
        alert("Please enter valid enterprise Id");
        this.IsRetriveData = false;
        this.loaderGif = false;
      } else if (
        this.rowData.toString() ==
        "Please Enter valid User EnterpriseID and ApplicationID"
      ) {
        alert(
          "Please enter valid enterprise Id or\nPlease enter valid application Id"
        );
        this.IsRetriveData = false;
        this.loaderGif = false;
      } else if (
        this.rowData.toString() == "Please Enter valid ApplicationID"
      ) {
        alert("Please enter valid application Id");
        this.IsRetriveData = false;
        this.loaderGif = false;
      } else if (this.rowData.length > 0) {
        this.IsRetriveData = true;
        this.IsDataToExport = true;
        this.loaderGif = false;
      } else {
        alert("No Data Available");
        this.IsRetriveData = false;
        this.loaderGif = false;
      }
    });
  }

  ExportToBulkExcel() {
    const randomRefresh = Date.now();
    let message = "";
    function validateAlpaNumeric(txtPhone) {
      const filter = /^$|^[A-Za-z0-9]+$/;
      if (filter.test(txtPhone)) {
        return true;
      } else {
        return false;
      }
    }
    function validateNumber(txtPhone) {
      //var filter = /^[0-9]+$/;
      const filter = /^[0-9]+/;
      if (filter.test(txtPhone)) {
        return true;
      } else {
        return false;
      }
    }
    function validatePhone(txtPhone) {
      const filter = /^[0-9-+]+$/;
      if (filter.test(txtPhone)) {
        return true;
      } else {
        return false;
      }
    }
    if (this.dlstDeviceType == "") {
      message = "Please Select Device Type";
    }
    if (this.dlstReportType == "") {
      message = message + "\n" + "Please Select Report Type";
    }
    if (this.Reports.startDateTime == "") {
      message = message + "\n" + "Please Select Start Date";
    }
    if (this.Reports.EndDate == "") {
      message = message + "\n" + "Please Select End Date";
    }
    if (this.IsCountryChecked) {
      //2023 Country Summary Report
      if (this.ReportType == "Country Summary Report") {
        if (this.Reports.SourceCountry == "") {
          message = message + "\n" + "Please Select From Country";
        }
        if (this.slectedToCountries.length == 0) {
          message = message + "\n" + "Please Select To Country";
        }
      } else {
        if (this.Reports.SourceCountry == "") {
          message = message + "\n" + "Please Select From Country";
        }
        if (this.Reports.DestinationCountry == "") {
          message = message + "\n" + "Please Select To Country";
        }
      }
    } else if (
      this.ReportType != "Dial In Conference Call Report" &&
      this.ReportType != "Gateway Report" &&
      this.ReportType != "SME Cluster Utilization Report"
    ) {
      if (this.ReportType == "Country Summary Report") {
        if (this.slectedCountries.length == 0)
          message = message + "\n" + "Please Select Country";
      } else if (this.Reports.Country == "" || this.Reports.Country == null) {
        message = message + "\n" + "Please Select Country";
      }
    }
    if (this.Reports.callingPartyNumber != "") {
      if (validatePhone(this.Reports.callingPartyNumber)) {
      } else {
        if (this.ReportType == "Common Area Phone Report") {
          message =
            message +
            "\n" +
            "Please Enter Numeric in Common Area Phone Number ";
        } else if (this.ReportType == "Dial In Conference Call Report") {
          message = message + "\n" + "Please Enter Numeric in Dial in Number";
        } else {
          message = message + "\n" + "Please Enter Numeric in Phone Number ";
        }
      }
    }
    if (this.Reports.CallerNo != "") {
      if (validatePhone(this.Reports.CallerNo)) {
      } else {
        message = message + "\n" + "Please Enter Numeric in Caller Number";
      }
    }
    if (this.Reports.CalleeNo != "") {
      if (validatePhone(this.Reports.CalleeNo)) {
      } else {
        message = message + "\n" + "Please Enter Numeric in Callee Number";
      }
    }
    // Validation for WBSE,AuthCode,Request Number;

    if (this.Reports.WBSE != "") {
      if (validateAlpaNumeric(this.Reports.WBSE)) {
      } else {
        message = message + "\n" + "Please Enter Valid WBS";
      }
    }
    if (this.Reports.RequestNumber != "") {
      if (validateAlpaNumeric("txtRequestNumber")) {
      } else {
        message = message + "\n" + "Please Enter Valid Request Number";
      }
    }
    if (this.Reports.AuthCode) {
      if (validateNumber(this.Reports.AuthCode)) {
      } else {
        message = message + "\n" + "Please Enter Valid AuthCode";
      }
    }
    if (this.Reports.Empno != "") {
      if (validateNumber(this.Reports.Empno)) {
      } else {
        message = message + "\n" + "Please Enter Valid Employee Number";
      }
    }
    if (this.ReportType == "SME Cluster Utilization Report") {
      if (this.slectedCountries.length == 0) {
        message = message + "\n" + "Please Select Country";
      }
      if (this.selectedSMECluster.length == 0) {
        message = message + "\n" + "Please Select SME Name";
      }
    }
    if (
      this.dlstReportType == "Call Summary Report" ||
      this.dlstReportType == "User Summary Reports" ||
      this.dlstReportType == "Common Area Phone Report"
    ) {
      const eid = this.Reports.eId;
      const keywordsArr = eid.split(",");

      if (keywordsArr.length > 5) {
        message =
          message + "\n" + "Please Enter Only 5 or less Enterprise Id's";
      }
    }

    if (message != "") {
      alert(message);
    } else {
      this.ReportType = this.dlstReportType;
      switch (this.ReportType) {
        case "Call Charge":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          } else {
            this.Type = "CallCharge";
          }
          break;
        /*2023 Requirement -- removal of Call Summary Report
        case 'Call Summary Report':
          if (this.dlstDeviceType == 'Teams') {
            this.Type = 'CallChargeTeams';
          }
          break;*/
        case "Project / Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GroupReportTeams";
          }
          break;
        case "Trunk Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "TrunkGroupReportTeams";
          } else {
            this.Type = "TrunkGroupReport";
          }
          break;
        case "Gateway Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GatewayReportTeams";
          } else {
            this.Type = "GatewayReport";
          }
          break;
        case "Country Wise Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CountryWiseReportTeams";
          } else {
            this.Type = "CountryWiseReport";
          }
          break;
        case "Dial In Calls Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "DialInCallsReportsTeams";
          } else {
            this.Type = "DialInCallsReports";
          }
          break;
        case "Authcode Mapping Report":
          this.Type = "AuthcodeMappingReport";
          break;
        case "SME Cluster Utilization Report":
          this.Type = "SMEClusterUtilization";
          break;
        case "Invalid WBSE Report":
          this.Type = "InvalidWBSEReport";
          break;
        /*2023 Requirement -- removal of Common Area Phone Report   Teams
        case 'Common Area Phone Report':
          if (this.dlstDeviceType == 'Teams') {
            this.Type = 'CommonAreaPhoneReportTeams';
          }
          break;*/
        case "Dial In Conference Call Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "DialInConferenceCallTeams";
          }
          break;
        case "User Summary Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "UserSummaryReports";
          }
          break;
        case "Country Summary Report":
          if (this.dlstDeviceType == "Teams") {
            if (this.IsCountryChecked) {
              this.Type = "CountrySummaryReportTeamsChecked";
            } else {
              this.Type = "CountrySummaryReportTeams";
            }
          }
          break;
        case "Location Summary Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "LocationSummaryReportTeams";
          }
          break;
      }
      const concString = "";
      let Project = "";
      let GatewayNames = "";
      const Telco = "";
      let FacilityNames = "";
      let calltypeNames = "";
      let destinationtypeNames = "";
      let DailInConfNo = "";
      let LocationNames = "";
      let SMEClusterName = "";

      for (var i = 0; i < this.selectedProjectNames.length; i++) {
        Project = Project + "," + this.selectedProjectNames[i].label;
      }
      for (var i = 0; i < this.selectedGateways.length; i++) {
        GatewayNames = GatewayNames + "," + this.selectedGateways[i].label;
      }
      for (var i = 0; i < this.slectedCallType.length; i++) {
        calltypeNames = calltypeNames + "," + this.slectedCallType[i].label;
      }
      for (var i = 0; i < this.selectedFacilities.length; i++) {
        FacilityNames = FacilityNames + "~" + this.selectedFacilities[i].label;
      }
      for (var i = 0; i < this.selectedLocation.length; i++) {
        LocationNames = LocationNames + "," + this.selectedLocation[i].label;
      }
      this.Reports.Location = LocationNames.slice(1, LocationNames.length);
      for (var i = 0; i < this.selectedDest.length; i++) {
        //destinationtypeNames = destinationtypeNames + ',' + this.selectedDest[i].label + ' Calls';
        destinationtypeNames =
          destinationtypeNames + "," + this.selectedDest[i].label;
      }
      for (var i = 0; i < this.selectedDailInConff.length; i++) {
        DailInConfNo = DailInConfNo + "," + this.selectedDailInConff[i].label;
      }
      if (this.ReportType == "SME Cluster Utilization Report") {
        var countrySummaryCountry = "";
        for (var i = 0; i < this.slectedCountries.length; i++) {
          countrySummaryCountry =
            countrySummaryCountry + "," + this.slectedCountries[i].label;
        }
        this.Reports.Country = countrySummaryCountry.slice(
          1,
          countrySummaryCountry.length
        );
        for (var i = 0; i < this.selectedSMECluster.length; i++) {
          SMEClusterName =
            SMEClusterName + "," + this.selectedSMECluster[i].label;
        }
        this.Reports.SMEName = SMEClusterName.slice(1, SMEClusterName.length);
      }

      this.Reports.Destination = destinationtypeNames.slice(
        1,
        destinationtypeNames.length
      );
      //this.Reports.destDeviceName = concString.slice(1, concString.length);
      this.Reports.ProjectName = Project.slice(1, Project.length);
      this.Reports.toGateway = GatewayNames.slice(1, GatewayNames.length);
      //this.Reports.telcoName = Telco.slice(1, Telco.length);;
      //this.Reports.ProjectLead = this.LoginEnterpriseID;
      this.Reports.Facility = FacilityNames.slice(1, FacilityNames.length);
      this.Reports.callType = calltypeNames.slice(1, calltypeNames.length);
      this.Reports.DailInConference = DailInConfNo.slice(
        1,
        DailInConfNo.length
      );
      // 2023 Country Summary Report
      if (this.ReportType == "Country Summary Report") {
        if (this.IsCountryChecked) {
          let countrySummaryToCountry = "";
          for (var i = 0; i < this.slectedToCountries.length; i++) {
            countrySummaryToCountry =
              countrySummaryToCountry + "," + this.slectedToCountries[i].label;
          }
          this.Reports.DestinationCountry = countrySummaryToCountry.slice(
            1,
            countrySummaryToCountry.length
          );
        } else {
          var countrySummaryCountry = "";
          for (var i = 0; i < this.slectedCountries.length; i++) {
            countrySummaryCountry =
              countrySummaryCountry + "," + this.slectedCountries[i].label;
          }
          this.Reports.Country = countrySummaryCountry.slice(
            1,
            countrySummaryCountry.length
          );
        }
      }
      this.loaderGif = true;
      this.TempUserKey = "";
      const ReportName = this.dlstReportType + ".xlsx";
      //2023 requirement Bulk upload feature for user summary report instead of 5 userid search
      this.Reports.BulkUploadUserId = "";
      if (this.bulkFile != "" && this.bulkFile != undefined && this.diveid) {
        this.loaderGif = true;
        const file = this.summaryReportFG.controls.inputFile.value;
        const ext = file.split(".").pop().toLowerCase();
        if (file == "") {
          alert("Please Upload The Template");
          this.loaderGif = false;
          return;
        }
        if (ext != "xls" && ext != "xlsx") {
          alert(
            "Please upload only Excel file with .xls or .xlsx extension only"
          );
          $("#fileControl").val("");
          this.loaderGif = false;
        } else {
          const formData = new FormData();
          formData.append("file", this.bulkFile);
          this.CAPService.UploadBulkEidTemplate(
            this.LoginEnterpriseID,
            formData
          ).subscribe((data) => {
            this.BulkUploaddata = data;
            //this.summaryReportFG.controls.inputFile.setValue('');
            this.TempUserKey = this.BulkUploaddata.TempUserName;
            if (this.TempUserKey != "") {
              this.Reports.BulkUploadUserId = this.TempUserKey;
              this.CAPService.ExportSummaryReports1(
                this.Reports,
                this.formatDateValue(this.Reports.startDateTime),
                this.formatDateValue(this.Reports.EndDate),
                this.Type
              ).subscribe(
                (data: Blob) => {
                  if (data.size > 0) {
                    if (
                      window.navigator &&
                      (window.navigator as any).msSaveOrOpenBlob
                    ) {
                      // for IE
                      (window.navigator as any).msSaveOrOpenBlob(
                        data,
                        ReportName
                      );
                      this.loaderGif = false;
                    } else {
                      const link = document.createElement("a");
                      link.href = window.URL.createObjectURL(data);
                      link.download = ReportName;
                      link.click();
                      this.loaderGif = false;
                    }
                  } else {
                    alert("No Records Found");
                    this.loaderGif = false;
                  }
                },
                function (x) {
                  console.log(x);
                  this.loaderGif = false;
                  alert("Acknowledgement failed");
                }
              );
            } else {
              this.loaderGif = false;
              alert(this.BulkUploaddata.StrMessage);
            }
          });
        }
      } else {
        this.Reports.BulkUploadUserId = this.Reports.eId;
        this.CAPService.ExportSummaryReports1(
          this.Reports,
          this.formatDateValue(this.Reports.startDateTime),
          this.formatDateValue(this.Reports.EndDate),
          this.Type
        ).subscribe(
          (data: Blob) => {
            if (data.size > 0) {
              if (
                window.navigator &&
                (window.navigator as any).msSaveOrOpenBlob
              ) {
                // for IE
                (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
                this.loaderGif = false;
              } else {
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(data);
                link.download = ReportName;
                link.click();
                this.loaderGif = false;
              }
            } else {
              alert("No Records Found");
              this.loaderGif = false;
            }
          },
          function (x) {
            console.log(x);
            this.loaderGif = false;
            alert("Acknowledgement failed");
          }
        );
      }
    }
  }
  setFile(files: FileList) {
    debugger;
    this.bulkFile = files.item(0);
    this.Reports.BulkUploadUserId = "";
  }
}

export class ReportDetails {
  public Country;
  public Facility;
  public callType;
  public eId;
  public callStatus;
  public startDateTime;
  public EndDate;
  public fromMediationServer;
  public toGateway;
  public destDeviceName;
  public callingPartyNumber;
  public ProjectName;
  public telcoName;
  public utilizationtype;
  public ProjectLead;
  public ValidInvalid;
  public Status;
  public WBSE;
  public originalCalledPartyNumber;
  public AuthCode;
  public MarkStatus;
  public RequestNumber;
  public CallingPartyNumber;
  public ExcludeNumber;
  public CallDirection;
  public CallStatus;
  public Location;
  public Destination;
  public Event;
  public CalleeNo;
  public CallerNo;
  public Column;
  public fromAuthcode;
  public toAuthcode;
  public fromCalling;
  public toCalling;
  public fromCalled;
  public toCalled;
  public fromExclude;
  public toExclude;
  public DailInConference;
  public Empno;
  public AuthStatus;
  public SourceCountry;
  public DestinationCountry;
  public BulkUploadUserId;
  // 2023 sprint 4 changes
  public SMEName;
}
